import { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { QRCodeCanvas } from "qrcode.react";

function Pagamento() {
  const { user } = useContext(AuthContext);
  const [valor, setValor] = useState("");
  const [erro, setErro] = useState(null);
  const saldo = user?.saldo ?? 200; // Se `user.saldo` for undefined, usa 200 como padrão

  const handleReceber = () => {
    if (!valor || valor <= 0 || valor > saldo) {
      setErro("Valor inválido. Insira um valor dentro do saldo disponível.");
      return;
    }
    setErro(null);
    alert("Pagamento gerado com sucesso!");
  };

  return (
    <div className="max-w-md mx-auto bg-white shadow p-6 rounded text-center">
      <h2 className="text-2xl font-bold mb-4">Receber Pagamento</h2>
      <div className="flex justify-center">
        <QRCodeCanvas value="https://cashbet.com.br/pagamento" size={200} />
      </div>
      <p className="mt-4">Escaneie o QR Code para receber o pagamento.</p>
      <input
        type="number"
        className="w-full p-2 border rounded mt-4"
        placeholder="Digite o valor"
        value={valor}
        onChange={(e) => setValor(e.target.value)}
        max={saldo}
      />
      {erro && <p className="text-red-500 mt-2">{erro}</p>}
      <button
        className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-800"
        onClick={handleReceber}
      >
        Receber
      </button>
      <p className="mt-2 text-sm text-gray-600">Saldo disponível: R$ {saldo.toFixed(2)}</p>
    </div>
  );
}

export default Pagamento;
